import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Zoom } from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import { ticketsTransition } from "../../../../services/TicketsServices";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom style={{ transitionDelay: "150ms" }} ref={ref} {...props} />;
});

export default function RefundRequestDialog({ open, row, onClose, onSubmit }) {
  const [notes, setNotes] = React.useState(row?.notes || "");
  const [submitting, setSubmitting] = React.useState(false);
  const [error, setError] = React.useState("");

  const handleDecision = async (decision) => {
    if (!row?.id) return;
    const action = decision === "approved" ? "approve_refund" : "reject_refund";
    try {
      setSubmitting(true);
      setError("");
      const res = await ticketsTransition("put", row?.id, {
        action,
        remarks: notes || "",
      });
      onSubmit?.(res);
    } catch (e) {
      const message = e?.response?.data?.message || e?.response?.data?.error || e?.message || "Failed to submit";
      setError(String(message));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} TransitionComponent={Transition} keepMounted fullWidth maxWidth={"sm"}>
      <DialogTitle color={"#616B88"} sx={{ fontSize: 24 }} className={"text-bold"} fontWeight={700}>
        Refund Review
      </DialogTitle>
      <Box className={"common-divider"} />
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <Chip label={`Ticket: ${row?.ticket_no || "-"}`} /> &nbsp;
            <Chip label={`Museum: ${row?.museum || "-"}`} />
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth size={"small"} label="Refund Notes" value={row?.reason || "-"} disabled />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              size={"small"}
              multiline
              minRows={3}
              label="Review Remarks"
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              disabled={submitting}
              error={Boolean(error)}
              helperText={error || ""}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant={"outlined"} color={"error"} className={"text-capitalize"} disabled={submitting}>
          close
        </Button>
        <Button
          onClick={() => handleDecision("rejected")}
          variant={"outlined"}
          color={"error"}
          className={"text-capitalize"}
          disabled={submitting}
        >
          Reject
        </Button>
        <Button onClick={() => handleDecision("approved")} variant={"contained"} className={"text-capitalize"} disabled={submitting}>
          Approve
        </Button>
      </DialogActions>
    </Dialog>
  );
}
